import React from 'react';
import moment from 'moment';

import ShiftDetailsForm from '../forms/ShiftDetailsForm';

import connectToStores from 'alt/utils/connectToStores';

import ShiftStore from '../stores/ShiftStore';

@connectToStores
class EditShiftDetails extends React.Component {

    static getPropsFromStores() {
        return {
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore];
    }

    componentDidMount() {
        const shift = this.props.shift;
        this.props.onChange(this.prepareDetailData(shift), this.refs.form.validate(true).errors, 1);
    }

    prepareDetailData(shift) {
        //console.log(shift);
        const detailData = {
            venue: shift.venue,
            description: shift.description,
            start_time: shift.start_time,
            end_time: shift.end_time,
            street_number: shift.street_number,
            street: shift.street,
            city: shift.city,
            lat: shift.lat,
            lng: shift.lng,
            zip: shift.zip,
            country: shift.country
        };
        const important_address_parts = [shift.street, shift.city, shift.country].filter(part => {
            if ( part && part !== "" && part.length > 0 ){
                return part;
            }
        });
        detailData.address = shift.formatted_address || important_address_parts.join(', ');
        const start_time = moment(shift.start_time).tz(shift.company.timezone).startOf('day');
        const cur_time = moment().tz(shift.company.timezone).startOf('day');
        detailData.start_date = start_time < cur_time ? undefined : start_time.format('DD.MM.YYYY');
        detailData.contact_persons = shift.contacts || undefined;
        return detailData;
    }

    onChange(value) {
        const errors = this.refs.form.validate(true).errors;
        this.props.onChange(value, errors, 1, true);
    }

    render () {
        const shift = this.props.shift;

        return (
            <div className={"edit-shift-details" + (this.props.isActive ? " active" : "")}>
                <div className="details-form-content">

                    <form onSubmit={e => e.preventDefault()} noValidate>
                        <ShiftDetailsForm shift={shift} disabled={this.props.disabled} onChange={this.onChange.bind(this)} initialFormData={this.prepareDetailData(shift)} errors={this.props.shiftStore.createError} ref="form" />
                    </form>
                </div>
            </div>
        );
    }
}

export default EditShiftDetails;



/** WEBPACK FOOTER **
 ** ./app/src/components/EditShiftDetails.js
 **/